import { render, staticRenderFns } from "./insert-short-url.vue?vue&type=template&id=4c6e2621&scoped=true"
import script from "./insert-short-url.vue?vue&type=script&lang=js"
export * from "./insert-short-url.vue?vue&type=script&lang=js"
import style0 from "./insert-short-url.vue?vue&type=style&index=0&id=4c6e2621&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6e2621",
  null
  
)

export default component.exports